const TournamentEnum = {
  DATE: 1,
  QUALIFICATION: 2,
  POSITION: 3,
};

Object.freeze(TournamentEnum);

export default TournamentEnum;
